// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__+kU4n","ring":"Avatar_ring__9oo6P","image":"Avatar_image__HxX4t","initials":"Avatar_initials__qZMqo"};